export default __webpack_public_path__ + "70e2635e3c8b29829919ed6c1c2794f5.mp3";